<div class="main-view space-y-2 md:space-y-4">
  <app-page-surface-header titleIcon="file"
    title="Document Types"
    subtitle="What each country asks a customer to present, how the number is validated, and what the AI service extracts from it."
  >
    <ng-container ngProjectAs="[pageHeaderActions]">
      <button
        type="button"
        class="btn inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-black shadow-none hover:bg-gray-50 disabled:opacity-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5"
        [disabled]="syncing"
        (click)="sync()"
      >
        <icon-refresh class="size-5" />
        <span>{{ syncing ? 'Syncing…' : 'Sync to tenants' }}</span>
      </button>
    </ng-container>
  </app-page-surface-header>

  @if (notice) {
  <output
    class="block rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800 dark:border-emerald-900/40 dark:bg-emerald-900/20 dark:text-emerald-300"
  >
    {{ notice }}
  </output>
  }

  <app-entity-catalog
    [catalog]="catalogView"
    [records]="records"
    [loading]="loading"
    [saving]="saving"
    [error]="error"
    [hideTitle]="true"
    [canCreate]="view === 'active'"
    [canEdit]="view === 'active'"
    [canDelete]="view === 'active'"
    [canRestore]="view === 'deleted'"
    [toolbarTabs]="toolbarTabs"
    [activeToolbarTab]="activeToolbarTab"
    [searchPlaceholder]="'Search code, country, category…'"
    (toolbarTabChange)="onToolbarTabChange($event)"
    (save)="onSave($event)"
    (delete)="onDelete($event)"
    (restore)="onRestore($event)"
  />
</div>

<app-delete-confirm-modal
  [open]="showDeleteModal"
  heading="Delete document type?"
  [entityName]="deleteEntityName"
  entityNoun="document type"
  message="This will remove the document type from the list. Run Sync to tenants afterwards to remove it from customer journeys."
  confirmLabel="Delete"
  loadingLabel="Deleting…"
  [loading]="deleteLoading()"
  [error]="deleteError"
  variant="permanent"
  (cancelled)="closeDeleteModal()"
  (confirmed)="submitDelete()"
/>

<app-restore-confirm-modal
  [open]="showRestoreModal"
  heading="Restore document type?"
  [entityName]="restoreEntityName"
  activeListLabel="document types list"
  [loading]="restoreLoading()"
  (cancelled)="closeRestoreModal()"
  (confirmed)="submitRestore()"
/>
